import React, { Component, Fragment } from 'react';
import autobind from 'autobind-decorator';
import classnames from 'classnames';
import { PRESET_PC, PRESET_TYPE_MOBILE, PRESET_TYPE_PC, PreviewMobilePresets } from '../../../constants/PreviewPreset';
import WindowEventHelper from '../../../lib/WindowEventHelper';
import { isDescendant } from '../../../lib/DomUtils';
import { PreviewCustomSizeInput } from './PreviewCustomSizeInput';

class PreviewLayerHeader extends Component {
  constructor (props) {
    super(props);
    this.state = {
      openMobilePreset: false,
    };
    this.mobilePresets = React.createRef();
    this.btnMobilePresets = React.createRef();
  }

  componentDidMount () {
    WindowEventHelper.add('click', this.handleToggleMobilePresets);
  }

  componentWillUnmount () {
    WindowEventHelper.remove('click', this.handleToggleMobilePresets);
  }

  @autobind
  handleToggleMobilePresets (e) {
    const elm = e.target;
    if (this.btnMobilePresets.current === elm ||
      (this.state.openMobilePreset && !isDescendant(this.mobilePresets.current, elm))) {
      e.preventDefault();
      e.stopPropagation();

      this.setState({
        openMobilePreset: !this.state.openMobilePreset,
      });
    }
  }

  handleChangePreset (e, preset) {
    const { onChangePreset } = this.props;
    const { openMobilePreset } = this.state;

    onChangePreset(preset);
    if (openMobilePreset) {
      this.setState({
        openMobilePreset: false,
      });
    }
  }

  render () {
    const { preset, width, height, onChangeWidth, onChangeHeight } = this.props;
    const { openMobilePreset } = this.state;

    const isCustom = preset.width !== width || preset.height !== height;

    return (
      <div className="layer_head">
        <strong className="tit_layer">미리보기</strong>
        <div className="preview_setting">
          <button
            className={classnames('mce-ico ico_pc', { active: preset.type === PRESET_TYPE_PC })}
            onClick={e => this.handleChangePreset(e, PRESET_PC)}
          >
            PC
          </button>

          <button
            ref={this.btnMobilePresets}
            className={classnames('mce-ico ico_mobile', { active: openMobilePreset || preset.type === PRESET_TYPE_MOBILE })}
            onClick={this.handleToggleMobilePresets}
          >
            Mobile
          </button>

          <div ref={this.mobilePresets} className="mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-fixed mce-menu-align mce-in "
            role="application" style={{ borderWidth: '1px', left: '4px', top: '48px', width: '140px', height: '171px', display: openMobilePreset ? 'block' : 'none' }}>
            <div className="mce-container-body mce-stack-layout" role="menu">
              {PreviewMobilePresets.map(item => <div
                key={item.name}
                className={classnames('mce-menu-item mce-menu-item-normal mce-stack-layout-item', { 'mce-active': preset.name === item.name })}
                role="menuitem"
                onClick={e => this.handleChangePreset(e, item)}
              >
                <span className="mce-text">{item.label}</span>
              </div>
              )}
            </div>
          </div>

          <strong className="screen_out">직접입력하기</strong>

          <PreviewCustomSizeInput
            title='가로해상도' value={width}
            onChange={onChangeWidth}
          />
          <span className="mce-ico ico_close_type1" />
          <PreviewCustomSizeInput
            title='세로해상도' value={height}
            onChange={onChangeHeight}
          />
        </div>
      </div>
    );
  }
}

export default PreviewLayerHeader;
